module.exports = __webpack_public_path__ + "img/sa.943cf62.svg";